import { useLocation } from "react-router-dom";

export function useIsPinPage() {
  const location = useLocation()
  return location.pathname.startsWith("/task/")
}
